import { Grid } from '@mui/material';
import React, {  } from 'react';
import './CargoTypeManagement.scss';
import PortManagementInput from './CargoTypeManagementInput';
import CargoTypeManagementTable from './CargoTypeManagementTable';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';

const CargoTypeManagement: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    return (
        <Grid container>
            <Grid container className="input-fields">
                <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                    <PortManagementInput></PortManagementInput>
                </div>
            </Grid>
            <Grid container className="datatable">
                <CargoTypeManagementTable>
                </CargoTypeManagementTable>
            </Grid>
        </Grid>
    )
};

export default CargoTypeManagement;